module.exports = __webpack_public_path__ + "img/tuxsuite_green_icons-04.bdcd51c0.png";